<template>
  <v-card>
    <v-toolbar flat height="50">
      <v-toolbar-title>Medical Details</v-toolbar-title>
    </v-toolbar>
    <div v-if="project" class="pa-4">
      <v-layout row wrap>
        <v-flex md3>
          <strong>Medical date </strong><br />
          <p>{{ project.medical_date }}</p>
        </v-flex>
        <v-flex md3>
          <strong>Medical Status</strong><br />
          <p>{{ valueToText(MEDICAL_STATUSES, project.medical_status)}}</p>
        </v-flex>
        <v-flex md3>
          <strong>Remark</strong><br />
          <p>{{ project.medical_notes}}</p>
        </v-flex>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
import {
  MEDICAL_STATUSES,
  VISA_TYPES,
  SERVICE_TYPES,
  PROJECT_OWNER,
} from "../../mdsir/const";

import {
  valueToText,
  getTV,
  districtTV,
  upazilaTV,
  unionTV,
} from "../../mdsir/MdsirUtils";

export default {
  props: ["project"],
  data() {
    return {
      MEDICAL_STATUSES: MEDICAL_STATUSES
    };
  },

  // computed: {},

  methods: {
    districtTV: districtTV,
    upazilaTV: upazilaTV,
    unionTV: unionTV,
    getTV: getTV,
    valueToText: valueToText,
  },

  // mounted() {},

  // watch: {},

  // beforeDestroy() {},

  // created() {},
};
</script>
